import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { SharedServiceService } from 'app/services/shared-service.service';
declare var $: any;
import { Config } from '@vendor/config/config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  version = this.config.version;
  xBuildNo = this.config.version.split('.').join('');
  constructor(public router: Router, private config: Config, private cookieService: CookieService, private sharedService: SharedServiceService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the auth header (fake value is shown here)
    if (this.xBuildNo.length === 2) {
      this.xBuildNo += '0';
    }
    let authReq: any = null;
    if (req.body && req.body.captcha) {
      authReq = req.clone({ headers: req.headers.set('Authorization', 'bearer ' + localStorage.getItem('currentToken')).set('X-Platform', 'PWA').set('X-BuildNo', this.xBuildNo).set('g-recaptcha-response', req.body.captcha).set('X-Version', this.version) }).clone({
        withCredentials: true
      });
    } else {
      authReq = req.clone({ headers: req.headers.set('Authorization', 'bearer ' + localStorage.getItem('currentToken')).set('X-Platform', 'PWA').set('X-BuildNo', this.xBuildNo).set('X-Version', this.version) }).clone({
        withCredentials: true
      });
    }
    return next.handle(authReq).pipe(tap(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const res: HttpResponse<Response> = event as HttpResponse<Response>;
          if (res.body['code'] === 102) {
            $('.modal').modal('hide');
            sessionStorage.clear();
            this.sharedService.pushNotification({
              message: 'توکن دسترسی شما ابطال شد. لطفا دوباره وارد شوید.'
            });
            if (localStorage.getItem('currentToken') && localStorage.getItem('mobileUserToken')) {
              if (localStorage.getItem('currentToken') !== localStorage.getItem('mobileUserToken')) {
                localStorage.setItem('currentToken', localStorage.getItem('mobileUserToken'));
                this.router.navigate(['/']);
                return;
              } else {
                localStorage.removeItem('currentToken');
                localStorage.removeItem('mobileUserToken');
                this.router.navigate(['register']);
                return;
              }
            }
            localStorage.removeItem('currentToken');
            localStorage.removeItem('mobileUserToken');
            this.router.navigate(['register']);
          }
          if (res.body['code'] === 104) {
            $('.modal').modal('hide');
            sessionStorage.clear();
            this.sharedService.pushNotification({
              message: 'توکن دسترسی شما ابطال شد. لطفا دوباره وارد شوید.'
            });
            if (localStorage.getItem('currentToken') && localStorage.getItem('mobileUserToken')) {
              if (localStorage.getItem('currentToken') !== localStorage.getItem('mobileUserToken')) {
                localStorage.setItem('currentToken', localStorage.getItem('mobileUserToken'));
                this.router.navigate(['/']);
                return;
              } else {
                localStorage.removeItem('currentToken');
                localStorage.removeItem('mobileUserToken');
                this.router.navigate(['register']);
                return;
              }
            }
            localStorage.removeItem('currentToken');
            localStorage.removeItem('mobileUserToken');
            this.router.navigate(['register']);
          }
          if (res.body['code'] === 105) {
            $('.modal').modal('hide');
            sessionStorage.clear();
            this.sharedService.pushNotification({
              message: 'توکن دسترسی شما ابطال شد. لطفا دوباره وارد شوید.'
            });
            localStorage.setItem('currentToken', localStorage.getItem('mobileUserToken'));
            this.router.navigate(['/']);
          }
          if (res.body['code'] === 3071) {
            $('.modal').modal('hide');
            sessionStorage.clear();
            this.sharedService.pushNotification({
              message: 'توکن دسترسی شما ابطال شد. لطفا دوباره وارد شوید.',
              success: false
            });
            localStorage.setItem('currentToken', localStorage.getItem('mobileUserToken'));
            this.router.navigate(['/']);
          }

          // do stuff with response if you want
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.log('req url :: ' + req.url);
          if (err.status === 401) {
            $('.modal').modal('hide');
            this.router.navigate(['register']);
          }
        }
      }
    ));
  }
}
